import { Button, Card, Form, Modal} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { useForm } from 'react-hook-form';
import { useEffect, useMemo, useState } from 'react';
import { useBackNavigation } from '../../../../hooks/BackNavigation';
import * as Yup from 'yup';
import {
  faCheck,
  faEdit,
  faInfoCircle,
  faRedo,
  faSave,
  faTimes,
  faUpload,
  faFolder,
  faShare
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  Navigate,
  useNavigate,
  useParams
} from 'react-router-dom';
import { AESDecrypt, AESEncrypt } from '../../../../encrypt-util';
import { AppDispatch, RootState } from '../../template/store';
import { useDispatch, useSelector } from 'react-redux';
import { agentInvite, getAgents, getBankNameList, getEblAgentOptions, getEBLDetails, getEBLHistory, getPartyNameList, submitEblActionRequest } from '../actions/eBLActions';
import { yupResolver } from '@hookform/resolvers/yup';
import { getOBLDetails } from '../../dashboard/actions/instruction';
import { toast } from 'react-toastify';
import useDataCountry from '../../../../hooks/useDataCountry';
import TncHandler from '../../../../components/common/TncHandler';
import { updateDashbaordRefresh } from '../../../common/components/DataTable/slices/DataTable';
import useBlCountry from '../../../../hooks/useBlCountry';


export interface RoleList {
  roleName: string;
  gsbnOrgId: string;
  partyName: string;
  roleId: number;
}


const EBL = () => {

  const { encrypt, blId} = useParams();
  const blNumber = useSelector((state: RootState) => state.oblDetails.oblForm.number);
  const dispatch = useDispatch<AppDispatch>();
  const eblData = useSelector((state: RootState) => state.eblDetails.eblData);
  const shipper = useSelector((state: RootState) => state.eblDetails.shipper);
  const consignee = useSelector((state: RootState) => state.eblDetails.consignee);
  const currentTitleHolder = useSelector((state: RootState) => state.eblDetails.titleHolder);
  const currentCustodian = useSelector((state: RootState) => state.eblDetails.custodian);
  const partyNameList = useSelector((state: RootState) => state.eblDetails.partyNames);
  const bankNameList = useSelector((state: RootState) => state.eblDetails.bankNames);
  const dataCountry = useDataCountry()
  const { t } = useTranslation();
  const navigate = useNavigate();

  interface Option {
    value: string;
    text: string;
  }


  const validationSchema = Yup.object().shape({
    currentTitleHolder: Yup.string()
      .when('eBLFormConfig.fields.currentTitleHolder.isHidden', {
        is: false,
        then: Yup.string().required('Current Title Holder is required'),
        otherwise: Yup.string().notRequired(),
      }),
    currentCustodian: Yup.string()
      .when('eBLFormConfig.fields.currentCustodian.isHidden', {
        is: false,
        then: Yup.string().required('Current Custodian is required'),
        otherwise: Yup.string().notRequired(),
      }),
    partyName: Yup.string()
      .when('eBLFormConfig.fields.partyName.isHidden', {
        is: false,
        then: Yup.string().required('Party Name is required'),
        otherwise: Yup.string().notRequired(),
      }),
    bank: Yup.string()
      .when('eBLFormConfig.fields.bank.isHidden', {
        is: false,
        then: Yup.string().required('Bank is required'),
        otherwise: Yup.string().notRequired(),
      }),
  });

  const inviteSchema = Yup.object().shape({
    inviteEmail: Yup.string()
      .email(t('resource_3:isInvalid', { field: t('resource_1:email') }))
      .required(t('resource_3:isRequired', { field: t('resource_1:email') })),

    // inviteRemarks: Yup.string()
    //   .required(t('resource_3:isRequired', { field: t('resource_1:remarks') })),
  });



  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    setError,
    trigger,
    clearErrors,
    formState: { errors, touchedFields },
  } = useForm<any>(
    {
      // resolver: yupResolver(validationSchema),
      mode: 'onChange',
    }
  );

  const {
  register: modalRegister,
  handleSubmit: handleModalSubmit,
  watch: modalWatch,
  reset: resetModalForm,
  formState: { errors: modalErrors }
} = useForm({
  resolver: yupResolver(inviteSchema),
});


  const [agent, setAgent] = useState('');
  const [actingParty, setActingParty] = useState('');
  const [endorsee, setEndorsee] = useState('');
  const [bank, setBank] = useState('');
  const [agentId, setAgentId] = useState<string | null>(null);
  
  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );

  const docType = AESDecrypt(encrypt);
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const partnerId = useSelector(
    (state: RootState) => state.userProfile.profile.partnerId
  );
   const language = useSelector((state:RootState)=> state.navbarTop.language);


  // const [tncDialog, setShowTncDialog] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  // const closeTncDialog = () => setShowTncDialog(false);
  // const showTncDialog = () => setShowTncDialog(true);

  useEffect(() => {
    if(blNumber){

      dispatch(getEBLDetails({ eBLNo: blNumber }))
    }
  
  }, [blNumber, docType]);



      const blIdDecrypted = AESDecrypt(blId)
  
      useEffect(() => {
          if (blIdDecrypted && selectedLinerId)
              dispatch(
                  getOBLDetails({
                      blNumber: blIdDecrypted || null,
                      selectedLinerId:
                          profileDetails.partnerType === 'liner'
                              ? profileDetails?.partnerId
                              : selectedLinerId,
                  })
              );
      }, [blIdDecrypted, selectedLinerId, docType]);



  useEffect(() => {
    clearErrors()
    dispatch(getPartyNameList());
    dispatch(getBankNameList());
    // dispatch(getAgents({ eBLNo: blNumber }));

  }, [dispatch, blNumber, docType]);

  useEffect(() => {

    if (currentTitleHolder) {
      setValue('currentTitleHolder', currentTitleHolder)
    }
    if (currentCustodian) {
      setValue('currentCustodian', currentCustodian)
    }


  }, [blNumber, currentTitleHolder, currentCustodian, docType])


  // useEffect(() => {

  //   setShipper("shipper1")
  //   setConsignee("consignee1")
  //   setAgent("agent1")
  //   setActingParty("shipper1")
  //   setEndorsee("endorsee1")
  //   setCurrentTitleHolder("shipper1");
  //   setCurrentCustodian("shipper1");
  // }, []);

  //state update


  const setupEBLFormConfig = (id: any) => {

    let eBLFormConfig = {

      fields: {
        currentTitleHolder: { isHidden: true, isDisabled: true },
        taxId: { isHidden: true, isDisabled: true },
        partyName: { isHidden: true, isDisabled: true, autoComplete: false },
        currentCustodian: { isHidden: true, isDisabled: true },
        agentName: { isHidden: true, isDisabled: true },
        bank: { isHidden: true, isDisabled: true, autoComplete: false },
        remarks: { isHidden: true, isDisabled: true },

      }

    }

    // setCurrentTitleHolder("abcd")
    // setCurrentCustodian("abcd")


    switch (id) {
      case 'TF':


        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === agent) && currentTitleHolder === shipper && currentCustodian === shipper) ||
        //   (actingParty === bank && currentTitleHolder === shipper && currentCustodian === bank)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: false, isDisabled: true, autoComplete: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            agentName: { isHidden: true, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', shipper)
          // setValue('currentCustodian', actingParty === "bank" ? bank : shipper)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)

          if (eBLFormConfig.fields.partyName.autoComplete) {
            setValue('partyName', consignee)
            // setPartyName(consignee) //a
          }


        // }

        break;
      case 'EC':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === agent) && currentTitleHolder === shipper && currentCustodian === shipper)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: false, isDisabled: true, autoComplete: true },
            agentName: { isHidden: true, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: false, isDisabled: false, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', shipper)
          // setValue('currentCustodian', shipper)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)

          if (eBLFormConfig.fields.partyName.autoComplete) {
            setValue('partyName', shipper)
            // setPartyName(shipper) //a
          }



        // }

        break;
      case 'EDTR':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === agent) && currentTitleHolder === shipper && currentCustodian === shipper) ||
        //   (actingParty === endorsee && currentTitleHolder === endorsee && currentCustodian === endorsee)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: false, isDisabled: false, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', actingParty === endorsee ? endorsee : shipper)
          // setValue('currentCustodian', actingParty === endorsee ? endorsee : shipper)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)

        // }

        break;
      case 'EDEC':
        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === agent) && currentTitleHolder === shipper && currentCustodian === shipper) ||
        //   (actingParty === endorsee && currentTitleHolder === endorsee && currentCustodian === endorsee)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: false, isDisabled: false, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: false, isDisabled: false, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', actingParty === endorsee ? endorsee : shipper)
          // setValue('currentCustodian', actingParty === endorsee ? endorsee : shipper)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)
        // }

        break;
      case 'AT':

        ///
          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: false, isDisabled: false },
            partyName: { isHidden: true, isDisabled: true, autoComplete: false },
            agentName: { isHidden: false, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: false, isDisabled: false },


          }

          // setValue('currentTitleHolder', actingParty === agent ? shipper : actingParty)
          // setValue('currentCustodian', actingParty)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)


        break;
      case 'AM':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === consignee || actingParty === endorsee) && currentTitleHolder === actingParty && currentCustodian === actingParty) ||
        //   (actingParty === agent && currentTitleHolder === shipper && currentCustodian === agent)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: true, isDisabled: true, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },

            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },

          }

          // setValue('currentTitleHolder', actingParty === agent ? shipper : actingParty)
          // setValue('currentCustodian', actingParty)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)


        // }

        break;
      case 'SRDV':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === consignee || actingParty === endorsee) && currentTitleHolder === actingParty && currentCustodian === actingParty)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: true, isDisabled: true, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', actingParty)
          // setValue('currentCustodian', actingParty)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)

        // }

        break;
      case 'CVPP':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === consignee || actingParty === endorsee) && currentTitleHolder === actingParty && currentCustodian === actingParty) ||
        //   (actingParty === agent && currentTitleHolder === shipper && currentCustodian === agent)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: true, isDisabled: true, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },
            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', actingParty === agent ? shipper : actingParty)
          // setValue('currentCustodian', actingParty)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)
        // }

        break;
      case 'WD':

        // if (
        //   // actingParty && currentTitleHolder && currentCustodian &&
        //   ((actingParty === shipper || actingParty === endorsee) && currentTitleHolder === actingParty && currentCustodian === actingParty) ||
        //   (actingParty === agent && currentTitleHolder === shipper && currentCustodian === agent)
        // ) {

          eBLFormConfig.fields = {

            currentTitleHolder: { isHidden: false, isDisabled: true },
            taxId: { isHidden: true, isDisabled: true },
            partyName: { isHidden: true, isDisabled: true, autoComplete: false },
            agentName: { isHidden: true, isDisabled: true },

            currentCustodian: { isHidden: false, isDisabled: true },
            bank: { isHidden: true, isDisabled: true, autoComplete: false },
            remarks: { isHidden: true, isDisabled: true },


          }

          // setValue('currentTitleHolder', actingParty === agent ? shipper : actingParty)
          // setValue('currentCustodian', actingParty)

          setValue('currentTitleHolder', currentTitleHolder)
          setValue('currentCustodian', currentCustodian)
        // }

        break;
      default:
        break;
    }
    return eBLFormConfig
  }
    const [inviteDialog, setShowInviteDialog] = useState(false);
    
    const closeInviteDialog = () => {
      resetModalForm()
      setShowInviteDialog(false)};
    const showInviteDialog = () => {
      resetModalForm()
      setShowInviteDialog(true)};

  const eBLFormConfig = useMemo(() => {
    return setupEBLFormConfig(docType)

  }, [docType, currentCustodian, currentTitleHolder, blNumber]);

    const form = useSelector((state:RootState)=>state.oblDetails.oblForm)

  const pod = form.pod?.substring(0, 2)
  const pol = form.pol?.substring(0, 2)
  const spol = form.startPol?.substring(0, 2)
  const fpod = form.fpod?.substring(0, 2)

  const [blCountry, setBlCountry] = useBlCountry(
    "new",
    (dataCountry === pod || dataCountry === fpod)
      ? "import"
      : "export",
    100
  );


  const linerIdSelected = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );



  const _onCloseForm = () => {

    const blIdDecrypted = AESDecrypt(blId ?? '')
    const blIdEncrypted = AESEncrypt(blIdDecrypted)
    navigate(`/ebl/${blIdEncrypted}/`)
  };

  const validateSubmission = (data: any) => {
    let isValid = true;

    if (!eBLFormConfig.fields.currentTitleHolder.isHidden && !eBLFormConfig.fields.currentTitleHolder.isDisabled) {
      if (!data.currentTitleHolder) {
        setError('currentTitleHolder', {
          message: t('resource_3:isRequired', { field: 'Current Title Holder' }),
        });
        isValid = false;
      }
    }

    if (!eBLFormConfig.fields.taxId.isHidden && !eBLFormConfig.fields.taxId.isDisabled) {
      if (!data.taxId) {
        setError('taxId', {
          message: t('resource_3:isRequired', { field: 'Tax Id' }),
        });
        isValid = false;
      }
    }

    if (!eBLFormConfig.fields.agentName.isHidden && !eBLFormConfig.fields.agentName.isDisabled) {
      if (!data.agentName) {
        setError('agentName', {
          message: t('resource_3:isRequired', { field: 'Agent Name' }),
        });
        isValid = false;
      }
    }



    if (!eBLFormConfig.fields.currentCustodian.isHidden && !eBLFormConfig.fields.currentCustodian.isDisabled) {
      if (!data.currentCustodian) {
        setError('currentCustodian', {
          message: t('resource_3:isRequired', { field: 'Current Custodian' }),
        });
        isValid = false;
      }
    }

    if (!eBLFormConfig.fields.partyName.isHidden && !eBLFormConfig.fields.partyName.isDisabled) {
      if (!data.partyName) {
        setError('partyName', {
          message: t('resource_3:isRequired', { field: 'Party Name' }),
        });
        isValid = false;
      }
    }

    if (!eBLFormConfig.fields.bank.isHidden && !eBLFormConfig.fields.bank.isDisabled) {
      if (!data.bank) {
        setError('bank', {
          message: t('resource_3:isRequired', { field: 'Bank' }),
        });
        isValid = false;
      }
    }

    //     if (!eBLFormConfig.fields.remarks.isHidden && !eBLFormConfig.fields.remarks.isDisabled) {
    //   if (!data.remarks) {
    //     setError('remarks', {
    //       message: t('resource_3:isRequired', { field: 'Remarks' }),
    //     });
    //     isValid = false;
    //   }
    // }

    return isValid;
  };

  const onSubmit = handleSubmit(async (payload) => {

    clearErrors()

    const isValid = validateSubmission(payload);

    if (!isValid) {
      return;
    }


    const titleHolder = eblData?.roleList.find((role:RoleList) => role.roleName === 'titleOwner')?.gsbnOrgId || null;

    const custodian = eblData?.roleList.find((role:RoleList) => role.roleName === 'blHolder')?.gsbnOrgId || null;



    dispatch(submitEblActionRequest({
      blNo: blNumber,
      // blNo: blNumber,
      // titleHolderOrgId: titleHolder,
      // custodianOrgId: custodian,
      linerId:linerId,
      actionRequest: docType,
      tAccept: termsAccepted,
      ...(docType === 'AT' && {
        agentOrgId: agentId,
        ...(payload?.remarks ? { remarks: payload?.remarks } : {}),
      }),


    })).unwrap().then((data)=>{
      if(data?.result){
        toast.success(data?.result)
      }
      if(data?.error){
         toast.error(data?.error)
      }
      const blIdDecrypted = AESDecrypt(blId ?? '')
      const blIdEncrypted = AESEncrypt(blIdDecrypted)
      setTimeout(() => {
        dispatch(getEBLHistory({ eBLNo: blNumber }))
        dispatch(updateDashbaordRefresh(true))
      }, 2000);    
      navigate(`/ebl/${blIdEncrypted}`)
    })
    

  });

  const onModalSubmit = handleModalSubmit(async (payload) => {

    dispatch(agentInvite({ email: payload?.inviteEmail, remark: payload?.inviteRemarks })).unwrap().then((data)=>{
        toast.success(data?.message)
    }).catch((error)=>{
      toast.error(error?.message)
    })

    resetModalForm()
    setShowInviteDialog(false)
  });


  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );

  // const containerDetails = useSelector(
  //   (state: RootState) => state.oblDetails.data
  // );

  // const partyList = containerDetails.partyList ?? [];

  // useEffect(() => {
  //   if (blNum && selectedLinerId)
  //     dispatch(
  //       getOBLDetails({
  //         blNumber: AESDecrypt(blNum) || null,
  //         selectedLinerId:
  //           profileDetails.partnerType === 'liner'
  //             ? profileDetails?.partnerId
  //             : selectedLinerId,
  //       })
  //     );
  // }, [blNum, selectedLinerId]);


  return (
    <Card style={{ minHeight: '100%' }}>
      <Card.Header
        className='d-flex align-items-center border-bottom bg-white sticky-top'
        style={{ zIndex: 10 }}>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg mb-1 me-1'
          onClick={_onCloseForm}
        />
        {/* t('resource_4:agent_nomination_to_carrier_from_consignee') */}
        <h2 className='fs-0 text-primary mb-1'>
          {' '}
          {docType === 'TF'
            ? "Transfer"
            : docType === 'EC'
              ? "Escrow"
              : docType === 'EDTR'
                ? "Endorse And Transfer"
                : docType === 'EDEC'
                  ? "Endorse And Escrow"
                  : docType === 'AT'
                    ? "Authorise"
                    : docType === 'AM'
                      ? "Amend"
                      : docType === 'SRDV'
                        ? "Surrender for delivery"
                        : docType === 'CVPP'
                          ? "Convert to Paper"
                          : docType === 'WD'
                            ? "Withdraw"
                            : ''}
        </h2>
      </Card.Header>
      <Card.Body>
        <div className='container'>

          <Form onSubmit={onSubmit} autoComplete='off'>
            <div className='row'>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.currentTitleHolder.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.currentTitleHolder.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Current Title Holder
                      <span>
                        {' '}
                      </span>
                    </Form.Label>
                    <Form.Control
                      size='sm'
                      {...register('currentTitleHolder')}
                      value={watch('currentTitleHolder')}
                      className={`fs--1 col-12 mb-1 form-control ${errors.currentTitleHolder ? 'is-invalid' : ''
                        }`}
                      // onChange={(e) => {
                      //   setCurrentTitleHolder(e.target.value)
                      //   setValue('currentTitleHolder', e.target.value);
                      // }}
                      //value={eBLFormConfig.fields.currentTitleHolder.defaultValue}
                      disabled={eBLFormConfig.fields.currentTitleHolder.isDisabled}
                    //   disabled={disableFields}
                    />
                    <div className='invalid-feedback'>
                      {errors.currentTitleHolder?.message?.toString()}
                    </div>
                  </Form.Group>
                )}
              </div>
              <div
                className={`col-12 mb-1 ${eBLFormConfig.fields.currentTitleHolder.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.taxId.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Authorize eBL {eblData?.blNo} to
                      <span>
                        {' '}
                      </span>
                    </Form.Label>
                    <Form.Control
                      size='sm'
                      {...register('taxId')}
                      value={watch('taxId')}
                      className={`fs--1 col-12 mb-1 form-control ${errors.taxId ? 'is-invalid' : ''
                        }`}
                      placeholder="Enter Tax Id"
                      disabled={eBLFormConfig.fields.taxId.isDisabled}
                      onBlur={(e: any) => {
                        // const newValue = e.target.value;
                         const newValue = e.target.value.trim();
                        if (newValue.trim() !== '') {
                          dispatch(
                            getEblAgentOptions({
                              eBLNo: blNumber,
                              taxId: newValue,
                              name: '',
                              country:blCountry
                            })
                          ).unwrap().then((response)=>{
                            const company = response?.find((data:any)=>{
                              return (data?.taxId === newValue)
                            })
                            if (!company) {
                              setValue('taxId', "")
                              setValue('agentName', "");
                              setAgentId(null)
                            } else {
                              setValue('agentName', company?.orgName ?? "")
                              setAgentId(company?.id ?? "")
                            }
                          }).catch((err) => {
                            setValue('taxId', "")
                            setValue('agentName', "");
                            setAgentId(null)
                            console.error("Agent lookup failed", err);
                          });
                        } else {
                          setValue('taxId', "")
                          setValue('agentName', "");
                          setAgentId(null)
                        } 
                        // setValue('taxId', newValue, { shouldDirty: true });  
                      }}
                    >
                    </Form.Control>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className='invalid-feedback d-block'>
                        {errors.taxId?.message?.toString()}
                      </div>
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.preventDefault();
                          showInviteDialog()
                        }}
                        className="fs--2 fw-bold"
                         style={{ whiteSpace: 'nowrap' }}
                      >
                        Register Agent on IQAX
                      </a>
                    </div>
                  </Form.Group>
                )}
              </div>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.agentName.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.agentName.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Agent Company Name
                      <span>
                        {' '}
                      </span>
                    </Form.Label>
                    <Form.Control
                      size='sm'
                      {...register('agentName')}
                      value={watch('agentName')}
                      className={`fs--1 col-12 mb-1 form-control ${errors.agentName ? 'is-invalid' : ''
                        }`}
                      disabled={eBLFormConfig.fields.agentName.isDisabled}
                    //   disabled={disableFields}
                    />
                    <div className='invalid-feedback'>
                      {errors.agentName?.message?.toString()}
                    </div>
                  </Form.Group>
                )}
              </div>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.partyName.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.partyName.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Party Name
                      <span>
                        {' '}

                      </span>
                    </Form.Label>
                    {eBLFormConfig.fields.partyName.autoComplete ? (

                      <Form.Control

                        size='sm'
                        {...register('partyName')}
                        value={watch('partyName')}
                        className={`fs--1 col-12 mb-1 form-control ${errors.partyName ? 'is-invalid' : ''
                          }`}

                        // onChange={(e) => {
                        //   setPartyName(e.target.value)
                        //   setValue('partyName', e.target.value);
                        // }}
                        disabled={eBLFormConfig.fields.partyName.isDisabled}
                      />

                    ) : (
                      <Form.Select
                        {...register('partyName')}
                        value={watch('partyName') || ''}
                        // defaultValue={partyName || ''}  
                        className={`fs--1 col-12 mb-1 form-control ${errors.partyName ? 'is-invalid' : ''
                          }`}
                        // onChange={(e) => {
                        //   setPartyName(e.target.value)
                        //   setValue('partyName', e.target.value);
                        // }}
                        disabled={eBLFormConfig.fields.partyName.isDisabled}
                      >
                        <option value='' disabled>Select Party</option>
                        {partyNameList && partyNameList.length > 0 && partyNameList?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))}
                        {/* {partyNameList.length > 0 ? (
                          partyNameList.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.text}
                            </option>
                          ))
                        ) : (
                          <option value="">No parties available</option> 
                        )}  */}

                      </Form.Select>
                    )}
                    <div className='invalid-feedback'>
                      {errors.partyName?.message?.toString()}
                    </div>
                  </Form.Group>
                )}

              </div>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.currentCustodian.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.currentCustodian.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Current Custodian
                      <span>
                        {' '}

                      </span>
                    </Form.Label>
                    <Form.Control
                      size='sm'
                      {...register('currentCustodian')}
                      value={watch('currentCustodian')}
                      // onChange={(e) => {
                      //   setCurrentCustodian(e.target.value)
                      //   setValue('currentCustodian', e.target.value);
                      // }}
                      className={`fs--1 col-12 mb-1 form-control ${errors.currentCustodian ? 'is-invalid' : ''
                        }`}
                      disabled={eBLFormConfig.fields.currentCustodian.isDisabled}
                    //   disabled={disableFields}
                    />
                    <div className='invalid-feedback'>
                      {errors.currentCustodian?.message?.toString()}
                    </div>
                  </Form.Group>
                )}
              </div>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.bank.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.bank.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Bank
                      <span>
                        {' '}

                      </span>
                    </Form.Label>
                    {eBLFormConfig.fields.bank.autoComplete ? (
                      <Form.Control
                        size='sm'
                        {...register('bank')}
                        value={watch('bank')}
                        // onChange={(e) => {
                        //   setBank(e.target.value)
                        //   setValue('bank', e.target.value);
                        // }}
                        className={`fs--1 col-12 mb-1 form-control ${errors.bank ? 'is-invalid' : ''
                          }`}
                        disabled={eBLFormConfig.fields.bank.isDisabled}

                      />
                    ) : (

                      <Form.Select
                        {...register('bank')}
                        value={watch('bank') || ''}
                        // onChange={(e) => {
                        //   setBank(e.target.value)
                        //   setValue('bank', e.target.value);
                        // }}
                        disabled={eBLFormConfig.fields.bank.isDisabled}
                        className={`fs--1 col-12 mb-1 form-control ${errors.bank ? 'is-invalid' : ''
                          }`}
                      >
                        <option value='' disabled>Select Bank</option>
                        {/* {bankList.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))} */}
                        {bankNameList && bankNameList.length > 0 && bankNameList?.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                    <div className='invalid-feedback'>
                      {errors.bank?.message?.toString()}
                    </div>
                  </Form.Group>
                )}
              </div>
              <div
                className={`col-12 mb-3 ${eBLFormConfig.fields.remarks.isHidden ? 'd-none' : ''}`}
              >
                {!eBLFormConfig.fields.remarks.isHidden && (
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      Remarks
                      <span>
                        {' '}
                      </span>
                    </Form.Label>
                    <Form.Control
                      size='sm'
                      {...register('remarks')}
                      value={watch('remarks')}
                      className={`fs--1 col-12 mb-1 form-control ${errors.remarks ? 'is-invalid' : ''
                        }`}
                      // onChange={(e) => {
                      //   setCurrentTitleHolder(e.target.value)
                      //   setValue('remarks', e.target.value);
                      // }}
                      //value={eBLFormConfig.fields.remarks.defaultValue}
                      disabled={eBLFormConfig.fields.remarks.isDisabled}
                    //   disabled={disableFields}
                    />
                    <div className='invalid-feedback'>
                      {errors.remarks?.message?.toString()}
                    </div>
                  </Form.Group>
                )}
              </div>
            </div>
            {
              <TncHandler
                country={dataCountry}
                language={language}

                module="GSBN"
                linerId={profileDetails.partnerType === 'liner'
                      ? profileDetails.partnerId
                      : linerIdSelected}

                termsAccepted={termsAccepted}
                setTermsAccepted={setTermsAccepted}
              />
            }
            <div className='d-flex justify-content-center align-items-center'>
              <Button
                className='me-2'
                variant='falcon-primary'
                size='sm'
                disabled={linerId == '1' && !termsAccepted}
                type='submit'>
                <FontAwesomeIcon icon={faSave} className='me-2' />
                Submit
              </Button>
            </div>
          </Form>
        </div>
        <Modal show={inviteDialog} onHide={closeInviteDialog} size='lg'>
          <Modal.Header className='p-2 pb-1' closeButton>
            {/* <Modal.Title>{t('resource_3:termsAndConditions')}</Modal.Title> */}
            <Modal.Title>Send Invite</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              overflow: 'auto',
              fontSize: '12px',
            }}
          >
            <div className="mb-3 fs--1">
              <h6 className="text-warning m-0 fs--1">
                The Agent isn't on  IQAX. Do you want to invite them to register on IQAX
              </h6>
              <br />
              <h6 className="text-warning m-0 fs--1">
                URL : <a
                  href="https://ebl2-ui-int.shrd-np.iqax.com/registration"
                  target="_blank"
                  rel="noopener noreferrer">
                  Click here to register!</a>
              </h6>
            </div>
            <div className="row">
              <div className="col-lg-6 mb-3">
                <Form.Group>
                  <Form.Label className='fs--1'>
                    {t('resource_2:emailAddress')}
                    <span>
                      {' '}
                    </span>
                  </Form.Label>
                  <Form.Control
                    size='sm'
                    type='email'
                    {...modalRegister('inviteEmail')}
                    value={modalWatch('inviteEmail')}
                    className={`fs--1 col-12 mb-1 form-control ${modalErrors.inviteEmail ? 'is-invalid' : ''
                      }`}
                  />
                  <div className='invalid-feedback fs--2'>
                    {modalErrors.inviteEmail?.message?.toString()}
                  </div>
                </Form.Group>
              </div>
              <div className="col-lg-6 mb-3">
                <Form.Group>
                  <Form.Label className='fs--1'>
                    Remarks
                    <span>
                      {' '}
                    </span>
                  </Form.Label>
                  <Form.Control
                    size='sm'
                    {...modalRegister('inviteRemarks')}
                    value={modalWatch('inviteRemarks')}
                    className={`fs--1 col-12 mb-1 form-control ${modalErrors.inviteRemarks ? 'is-invalid' : ''
                      }`}
                  />
                  <div className='invalid-feedback fs--2'>
                    {modalErrors.inviteRemarks?.message?.toString()}
                  </div>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="d-flex justify-content-center align-items-center">
              <Button
                variant="falcon-primary"
                size="sm"
                className="me-2"
                onClick={() => {
                  onModalSubmit()
                  // modalCloseFocus.current.focus();
                  // setShowPaymentConfirm(false);
                }}
              >
                <FontAwesomeIcon icon={faShare} className='ps-1 me-2'
                  style={{ color: '#f5822a' }}
                  size='lg' />
                Share
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );

};

export default EBL;
